<template>
  <div class="event-container">
    <event-cards :events="events" class="user-event-cards"/>
  </div>
</template>

<script>
import EventCards from '@/components/event/view/EventCards.vue';

export default {
  name: 'profile-events',
  components: {
    EventCards,
  },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.user-event-cards {
  text-align: left;
}

</style>
